var MiniCart = {
    init: function () {
        Debug.log("MINI CART INIT V2");
        var swiper = new Swiper(".reassurances--cart", {
          centeredSlides: true,
          autoplay: {
            delay: 2500,
            disableOnInteraction: false,
          },
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
          loop: true
        });
        var swiper_mobile = new Swiper(".reassurances--cart-mobile", {
          centeredSlides: true,
          autoplay: {
            delay: 2500,
            disableOnInteraction: false,
          },
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
          loop: true
        });
        // swiper.init();
        Debug.log(Swiper);
        $(document).on("click", ".product-remove", function(e){
            console.log("CLICK REMOVE :" + $(this).closest(".mini-cart-item").find("input.qty").val());
            $(this).closest(".mini-cart-item").addClass("removing");
            $(this).closest(".mini-cart-item").find("input.qty").val(0);
            $(this).closest(".mini-cart-item").find("input.qty").change();
        })

        $(".header .woocommerce-cart").on("click touchend", function (e) {
            if (e.type == "touchend") {
                $(this).off("click");
            }
            MiniCart.open_cart();
        });

        setTimeout(function () {
            $("body").on("wc_fragments_loaded", function () {
                Debug.log("WC_Fragments_Loaded");
                MiniCart.bind_events();
                MiniCart.open_cart();
            });
        }, 2000);


    },
    bind_events: function () {

    },
    open_cart: function () {
        $(".mini-cart-container").addClass("open");

        $(".mini-cart-container .shadow").off("click touchend");
        $(".mini-cart-container .close").off("click touchend");
        $(".mini-cart-container .continu-shopping").off("click touchend");
        $(".additional-product-container .no").off("click touchend");

        CustomQuantity.init();

        setTimeout(function () {
            $(".mini-cart-container .shadow").on("click touchend", function (e) {
                Debug.log("CLICK SHADOW");
                if (e.type == "touchend") {
                    $(this).off("click");
                }

                MiniCart.close_cart();
            });

            $(".mini-cart-container .close").on("click touchend", function (e) {
                if (e.type == "touchend") {
                    $(this).off("click");
                }

                MiniCart.close_cart();
            });

            $(".mini-cart-container .continu-shopping").on("click touchend", function (e) {
                if (e.type == "touchend") {
                    $(this).off("click");
                }
                MiniCart.close_cart();
            });

            $(".mini-cart-header .btn-retour").on("click touchend", function (e) {
                if (e.type == "touchend") {
                    $(this).off("click");
                }
                Debug.log("CLICK CLOSE CART");
                MiniCart.close_cart();
            });
            $(".additional-product-container .no").on("click touchend", function () {
                Debug.log("NO MEANS NO");
                $(".additional-product-container").addClass("hidden");
            });

        }, 100);

    },
    close_cart: function () {

        $(".mini-cart-container .shadow").off("click touchend");
        $(".mini-cart-container").removeClass("open");
    }
}

$(window).load(function () {

    Debug.log("WINDOW LOAD : " + $(".mini-cart-container").length);

    if ($(".mini-cart-container").length) {
        MiniCart.init();

    }
})
